import * as React from 'react'

const SvgDownloadAllIcon = (props) => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6673 10.4166V5.66663C14.6673 4.26649 14.6673 3.56643 14.3948 3.03165C14.1552 2.56124 13.7727 2.17879 13.3023 1.93911C12.7675 1.66663 12.0674 1.66663 10.6673 1.66663H5.33398C3.93385 1.66663 3.23379 1.66663 2.69901 1.93911C2.2286 2.17879 1.84615 2.56124 1.60647 3.03165C1.33398 3.56643 1.33398 4.26649 1.33398 5.66663V14.3333C1.33398 15.7334 1.33398 16.4335 1.60647 16.9683C1.84615 17.4387 2.2286 17.8211 2.69901 18.0608C3.23379 18.3333 3.93381 18.3333 5.33387 18.3333H8.41732M9.66732 9.16663H4.66732M6.33398 12.5H4.66732M11.334 5.83329H4.66732M10.5007 15.8333L13.0007 18.3333M13.0007 18.3333L15.5007 15.8333M13.0007 18.3333V13.3333"
      stroke="#344054"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgDownloadAllIcon
